import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import SmoothScroll from "../components/SmoothScroll";
import Navbar from "../components/landing/Navbar";
import OfferBanner from "../components/landing/OfferBanner";
import Hero from "../components/landing/Hero";
import EditorialMarquee from "../components/landing/Marquee";
import Fleet from "../components/landing/Fleet";
import Showcase from "../components/landing/Showcase";
import Process from "../components/landing/Process";
import Terms from "../components/landing/Terms";
import Verify from "../components/landing/Verify";
import Reviews from "../components/landing/Reviews";
import Gallery from "../components/landing/Gallery";
import Footer from "../components/landing/Footer";
import StickyCTA from "../components/landing/StickyCTA";
import { api } from "../lib/site";

export default function Landing() {
  const [offer, setOffer] = useState(null);
  const [instagramUrl, setInstagramUrl] = useState("");

  useEffect(() => {
    api.get("/settings").then(({ data }) => {
      setInstagramUrl(data.instagram_url || "");
      const notExpired = !data.offer_ends_at || new Date(data.offer_ends_at).getTime() > Date.now();
      if (data.offer_enabled && data.offer_text && notExpired && localStorage.getItem("rac_offer_dismissed") !== data.offer_text) {
        setOffer({ text: data.offer_text, endsAt: data.offer_ends_at, color: data.offer_color || "#D6FF00" });
      }
    }).catch(() => {});
  }, []);

  const dismissOffer = () => {
    if (offer) localStorage.setItem("rac_offer_dismissed", offer.text);
    setOffer(null);
  };

  return (
    <SmoothScroll>
      <div className="noise-overlay relative bg-ink" data-testid="landing-page">
        <Toaster theme="dark" position="top-center" richColors />
        {offer && <OfferBanner text={offer.text} endsAt={offer.endsAt} color={offer.color} onClose={dismissOffer} onExpire={() => setOffer(null)} />}
        <Navbar hasOffer={!!offer} />
        <Hero />
        <EditorialMarquee />
        <Fleet />
        <Showcase />
        <Process />
        <Terms />
        <Verify />
        <Reviews />
        <Gallery instagramUrl={instagramUrl} />
        <Footer instagramUrl={instagramUrl} />
        <StickyCTA />
      </div>
    </SmoothScroll>
  );
}
